import React, { FC } from 'react';
import {
  Modal,
  Content,
  WarningIcon,
  Text,
  WrapperButton,
  Button,
} from './styles';
import { Props } from './types';

const AskBeforeDelete: FC<Props> = ({ message, handleRemove, handleClose }) => {
  const handleConfirm = () => {
    handleRemove();
    handleClose();
  };

  return (
    <Modal open handleClose={handleClose}>
      <Content>
        <WarningIcon />
        <Text>{message}</Text>
        <WrapperButton>
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button type="button" color="destructive" onClick={handleConfirm}>
            Delete
          </Button>
        </WrapperButton>
      </Content>
    </Modal>
  );
};

export default AskBeforeDelete;

// TODO: TFR-29 add story to component
